/*import { Libs } from ' --- libs/libs'
import moment from 'moment'*/
export default {
  namespaced: true,
  state: {
    msnSetSenha: "",
    logado: false,
    usuarioLogado: null,
    dadosUsuario: {
      id: "",
      usuario: "",
      email: "",
      cpf: "",
      ativo: "",
      data_cadastro: null,
      key: null,
    },
  },
  getters: {
    getLogado(state) {
      return state.logado;
    },
    getMsnSetSenha(state) {
      return state.msnSetSenha;
    },
    getDadosUsuario(state) {
      return state.dadosUsuario;
    },
    getUsuarioLogado(state) {
      return state.usuarioLogado;
    },
  },
  mutations: {
    setUsuarioLogado(state, payload) {
      state.usuarioLogado = payload;
    },
    setMsnSetSenha(state, payload) {
      state.msnSetSenha = payload;
    },
    setDadosUsuario(state, payload) {
      state.dadosUsuario = payload;
    },
    setLogado(state, payload) {
      state.logado = payload;
    },
  },
  actions: {},
};
